import { type FC, type ReactNode, type RefObject, useRef } from 'react'
import { useIntl } from 'react-intl'

import { type BannerData } from '../../../ad-server'
import { AD_BANNER_AUTO_REFRESH_SLIDE_ID } from '../../adServerConst'

import { AdServerBannerNavigation } from './AdServerBannerNavigation'

type AdServerBannerWrapperProps = {
  bannerData?: BannerData
  bannerRef: RefObject<HTMLDivElement | null>
  children: ReactNode
  className?: string
  isCarousel: boolean
}

export const AdServerBannerWrapper: FC<AdServerBannerWrapperProps> = ({
  bannerData,
  bannerRef,
  children,
  isCarousel,
  ...restProps
}) => {
  const intl = useIntl()
  const carouselRef = useRef<HTMLElement>(null)

  if (!isCarousel) {
    return <div {...restProps}>{children}</div>
  }

  const adBannerTitle = intl.formatMessage({
    id: 'adBanner.title',
  })

  return (
    <section
      aria-label={intl.formatMessage({
        id: 'adBanner.carousel.aria',
      })}
      aria-roledescription="carousel"
      className="relative w-fit max-w-full"
      ref={carouselRef}
    >
      <section
        aria-roledescription="slide"
        id={AD_BANNER_AUTO_REFRESH_SLIDE_ID}
        {...restProps}
      >
        {children}
      </section>
      {bannerData ? (
        <>
          {bannerData.totalCount > 1 ? (
            <AdServerBannerNavigation
              bannerRef={bannerRef}
              carouselRef={carouselRef}
              currentIndex={bannerData.currentIndex}
              totalCount={bannerData.totalCount}
            />
          ) : null}
          <span aria-live="polite" className="sr-only">
            {adBannerTitle}
            {' - '}
            {bannerData.currentIndex + 1}
            {' / '}
            {bannerData.totalCount}
          </span>
        </>
      ) : null}
    </section>
  )
}
